/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM, useToggle } from "@adapptio/lib-components";
import { IModalBaseProps, ModalBase } from "../ModalBase";
import { overrideForwardRef } from "../OverridableComponent";

import "./Modal.scss";

export interface IModalProps extends IModalBaseProps {
	className?: string;
}

export const Modal = overrideForwardRef<IModalProps, "div">(
	({ Component, className, open, children, ...props }, ref) => {
		const [ exited, , setExited, setNotExited ] = useToggle(true);

		const baseClass = BEM("edt-modal", null, { open, exited });

		if (className) {
			baseClass.add(className);
		}

		return (
			<ModalBase
				open={open}
				Component={Component}
				ref={ref}
				onTransitionEnter={setExited}
				onTransitionExited={setNotExited}
				className={baseClass.toClassName()}
				{...props}
			>
				{children}
			</ModalBase>
		);
	}
);

Modal.defaultProps = {
	Component: "div"
};
